import routerOptions0 from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}